import { OTHER } from "../../../../../consts";
import { FORM_KEYS, getAge } from "../helper";
import { format } from "date-fns";

const PatientDetails = ({ formData }) => {
    return (
        <>
            <h6 className="">Patient Details</h6>
            <hr className="m-0 p-0" />
            <div className="row mt-3 px-2">
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                    <p className="label">
                        Patient Name
                    </p>
                    <p className="value">
                        {formData[FORM_KEYS.patient]?.value?.name}
                    </p>
                </div>

                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                    <p className="label">
                        Patient Relationship
                    </p>
                    <p className="value">
                        {formData[FORM_KEYS.patient]?.value?.relation || "--"}
                    </p>
                </div>

                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                    <p className="label">
                        Date of Birth & Age
                    </p>
                    <p className="value">
                        {formData[FORM_KEYS.patient]?.value?.dob ? `${format(formData[FORM_KEYS.patient]?.value?.dob, "dd-MM-yyyy")} - ${getAge(format(formData[FORM_KEYS.patient]?.value?.dob, "dd-MM-yyyy"))}` : "--"}
                    </p>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                    <p className="label">
                        Gender
                    </p>
                    <p className="value">
                        {formData[FORM_KEYS.patient]?.value?.gender || "--"}
                    </p>
                </div>

                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                    <p className="label">
                        Member ID
                    </p>
                    <p className="value">
                        {formData[FORM_KEYS.patient]?.value?.member_id || "--"}
                    </p>
                </div>

                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                    <p className="label">
                        Alternate Mobile Number
                    </p>
                    <p className="value">
                        {formData[FORM_KEYS.alternate_mobile_number] || "--"}
                    </p>
                </div>

            </div>
        </>
    );
};

export default PatientDetails;
